import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { QueryClient, QueryClientProvider } from 'react-query';
var queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
export var AppProviders = function AppProviders(props) {
  return _jsx(_Fragment, {
    children: _jsx(QueryClientProvider, {
      client: queryClient,
      children: props.children
    })
  });
};